import { authedApiFetch } from 'utils/Api';

// authedApiFetch only forwards a backend message when the body has `error`, and
// this endpoint answers with `errors`, so the raw response is handled here to
// keep the validation details. See buildApiError
const request = async ({ endpoint, method, payload }) => {
	let response;

	try {
		response = await authedApiFetch({
			endpoint,
			method,
			payload,
			returnResponse: true,
		});
	} catch (err) {
		// authedApiFetch stringifies transport and token failures into a
		// developer-facing message; never surface that to the user
		console.error(
			'Health score weighting request failed to reach the API:',
			err
		);

		throw buildApiError({ isNetworkError: true });
	}

	const body = await response.json().catch(() => ({}));

	if (!response.ok) {
		throw buildApiError({ status: response.status, body });
	}

	return body;
};

// The thrown error carries the backend details so the feature layer can turn
// them into user-facing copy. See getHealthScoreWeightingErrorMessage
const buildApiError = ({ status, body, isNetworkError = false }) => {
	const errors = Array.isArray(body?.errors)
		? body.errors.filter(Boolean)
		: [body?.error].filter(Boolean);

	const error = new Error(
		errors[0] || `Health score weighting request failed with status ${status}`
	);

	error.isApiError = true;
	error.isNetworkError = isNetworkError;
	error.statusCode = status;
	error.errors = errors;

	return error;
};

const healthScoreWeightingService = {
	getHealthScoreWeighting: async (tenantId) => {
		return await request({
			endpoint: `/tenants/${tenantId}/health_score_weighting`,
			method: 'GET',
		});
	},

	updateHealthScoreWeighting: async (tenantId, weights) => {
		return await request({
			endpoint: `/tenants/${tenantId}/health_score_weighting`,
			method: 'PATCH',
			payload: {
				weights,
			},
		});
	},
};

export default healthScoreWeightingService;
